import { ChangeEvent, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  TextInput,
  PasswordInput,
  Paper,
  Title,
  Container,
  Button,
  Text,
  Switch,
  useMantineColorScheme,
} from "@mantine/core";
import classes from "./AuthenticationTitle.module.css";
import { HeaderSimple } from "./Header";
import axiosLogin from "../../api/axios";
import { useForm } from "@mantine/form";
import useAuth from "../../auth/useAuth";
import { showErrorAlert } from "../../helper/alerts";

export default function AuthenticationTitle({ }: {}) {
  const navigate = useNavigate();

  const location = useLocation();

  const form = useForm({
    initialValues: {
      email: "",
      password: "",
    },
    validate: {
      email: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
    },
  });

  const handleEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    form.setValues({ ...form.values, email: event.target.value });
  };

  const handlePasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
    form.setValues({ ...form.values, password: event.target.value });
  };

  const { setAuth } = useAuth();
  const [err, setErr] = useState<string>("");

  const isAdmin = location.pathname.split("/")[1] === "admin";

  const handleLogin = async () => {
    // const endpoint = isAdmin
    //   ? "/api/admin/auth/login"
    //   : "/api/staff/auth/login";
    const endpoint = "/api/admin/auth/login"
    await axiosLogin
      .post(endpoint, form.values, {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data
        // console.log(data)
        setAuth({
          token: data.token,
          name: data.userDetails.fullname,
          role: data.userDetails.role,
        });
        const role = data.userDetails.role;
        if (data.userDetails.userType === "admin") {
            if(role === 'admin' || role === 'content')
                navigate("/feed")
            else if(role === 'manager')
                navigate("/dealer")
            else if(role === 'price-list')
                navigate("/pdf-price-list")
            else 
                showErrorAlert("Unable to login")
        }
        else if (data.userDetails.userType === "staff") navigate("/staff/dashboard");
      })
      .catch((err) => {
        if (!err.response)
          showErrorAlert("Network error")
        else if (err.response.data) setErr("Invalid Credentials");
      });
  };

  const handleSwitchToggle = () => {
    navigate(isAdmin ? "/staff/login" : "/admin/login");
  };

  return (
    <div className={classes.background}>
      ;
      <Container className={classes.container}>
        <Paper className={classes.paper}>
          <HeaderSimple />
          <Title className={classes.title}>Login</Title>
          {/* <Text
            className={classes.co_title}
            style={{ color: isAdmin ? "blueviolet" : "blue" }}
          >
            {isAdmin ? "Admin" : "Staff"}
          </Text> */}
          <form onSubmit={form.onSubmit(handleLogin)}>
            <TextInput
              label="Email"
              placeholder="you@email.com"
              maxLength={255}
              required
              radius={10}
              style={{ textAlign: "left" }}
              {...form.getInputProps("email")}
              value={form.values.email}
              onChange={handleEmailChange}
            />

            <PasswordInput
              label="Password"
              placeholder="Your password"
              maxLength={255}
              required
              mt="md"
              radius={10}
              style={{ textAlign: "left" }}
              {...form.getInputProps("password")}
              value={form.values.password}
              onChange={handlePasswordChange}
            />
            <Text mt="lg" c={"red.8"}>
              {err}
            </Text>
            <Button
              fullWidth
              mt={"xs"}
              radius={10}
              color="blueviolet"
              type="submit"
            >
              Login
            </Button>
          </form>{" "}
          {/* <Switch
            mt={"lg"}
            checked={!isAdmin}
            onChange={handleSwitchToggle}
            size="xl"
            styles={{
              track: {
                backgroundColor: isAdmin ? "blueviolet" : "blue", // Set color for the off state
                color: isAdmin ? "white" : "white",
              },
            }}
            onLabel="STAFF"
            offLabel="ADMIN"
            style={{
              width: "80px",
              marginLeft: "auto",
              marginRight: "0",
            }}
          ></Switch> */}
        </Paper>
      </Container>
    </div>
  );
}
